<template>
  <LocationGroupsSearchFilter
    :id="id"
    v-model="modelValue"
    stop-type="origin"
  />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { OrderSearchCriteria, ShipmentSearchCriteria } from '@/model';

import LocationGroupsSearchFilter from '@/components/search/LocationGroupsSearchFilter.vue';

const modelValue = defineModel({
  type: Object as PropType<OrderSearchCriteria | ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);
</script>
